import { Flex } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

import HaveAccountFooter from "components/HaveAccountFooter";
import { FixedButtonsWrapper, OFButton } from "design_system/components/OFButton";
import { colors } from "src/colors";
import { useCheckPatientLogIn } from "src/hooks";

type Props = {
  onClick(): void;
};
export const CompleteYourHelpProfile = ({ onClick }: Props) => {
  const { t } = useTranslation("evaluation");
  const { isGuest } = useCheckPatientLogIn();

  return (
    <FixedButtonsWrapper bothViewport bg={colors.green[900]}>
      <Flex flexDir={["column", "row"]} gap={3} align="center">
        <OFButton textTransform="capitalize" onClick={onClick}>
          {t("get-started.action")}
        </OFButton>

        {isGuest && <HaveAccountFooter theme="dark" />}
      </Flex>
    </FixedButtonsWrapper>
  );
};
